import classes from './Notes.module.css';
import React from 'react';
import Sidebar from './Sidebar';
import InputForm from './InputForm';

export default function Notes(props) {
  return (
    <>
      <div className={classes.main}>
        <Sidebar sidebar={props.sidebar}></Sidebar>
        <InputForm />
      </div>
    </>
  );
}
